import React from "react";
import ArrowRight from "./arrow-right";
import Check from "./check";
import ChevronLeft from "./chevron-left";
import ChevronRight from "./chevron-right";
import ChevronDown from "./chevron-down";
import ChevronDownBold from "./chevron-down-bold";
import ChevronDownSelect from "./chevron-down-select";
import Close from "./close";
import Document from "./document";
import EmailShare from "./email-share";
import FacebookShare from "./facebook-share";
import Vimeo from "./vimeo";
import Info from "./info";
import LinkedIn from "./linkedin";
import LinkedInShare from "./linkedin-share";
import Logo from "./logo";
import More from "./more";
import Play from "./play";
import Twitter from "./twitter";
import TwitterShare from "./twitter-share";
import YouTube from "./youtube";
import Plus from "./plus";
import Minus from "./minus";
import DotsHeader from "./dots-header";
import DotsHeaderM from "./dots-header-m";
import DotsHeaderImg from "./dots-header-img";
import DotsHeaderImgM from "./dots-header-img-m";
import DotsAbout from "./dots-about";
import DotsAboutM from "./dots-about-m";
import DotsCta from "./dots-cta";
import DotsCtaM from "./dots-cta-m";
import DotsHome from "./dots-home";
import DotsHomeM from "./dots-home-m";

function Icon(props) {
  switch (props.symbol) {
    case "arrow-right":
      return <ArrowRight />;
    case "check":
      return <Check />;
    case "chevron-left":
      return <ChevronLeft />;
    case "chevron-right":
      return <ChevronRight />;
    case "chevron-down":
      return <ChevronDown />;
    case "chevron-down-bold":
      return <ChevronDownBold />;
    case "chevron-down-select":
      return <ChevronDownSelect />;
    case "document":
      return <Document />;
    case "info":
      return <Info />;
    case "close":
      return <Close />;
    case "email-share":
      return <EmailShare />;
    case "facebook-share":
      return <FacebookShare />;
    case "vimeo":
      return <Vimeo />;
    case "linkedin":
      return <LinkedIn />;
    case "linkedin-share":
      return <LinkedInShare />;
    case "logo":
      return <Logo />;
    case "more":
      return <More />;
    case "play":
      return <Play />;
    case "twitter":
      return <Twitter />;
    case "twitter-share":
      return <TwitterShare />;
    case "youtube":
      return <YouTube />;
    case "plus":
      return <Plus />;
    case "minus":
      return <Minus />;
    case "dots-header":
      return <DotsHeader />;
    case "dots-header-m":
      return <DotsHeaderM />;
    case "dots-header-img":
      return <DotsHeaderImg />;
    case "dots-header-img-m":
      return <DotsHeaderImgM />;
    case "dots-about":
      return <DotsAbout />;
    case "dots-about-m":
      return <DotsAboutM />;
    case "dots-cta":
      return <DotsCta />;
    case "dots-cta-m":
      return <DotsCtaM />;
    case "dots-home":
      return <DotsHome />;
    case "dots-home-m":
      return <DotsHomeM />;
    default:
      return <span>Unknown icon: {props.symbol}</span>;
  }
}

export default Icon;
